import { SearchInput } from "@components/Input";
import { AddressSuggestionList } from "@components/List/AddressSuggestionList";
import { OnboardingLayoutProps } from "@components/OnboardingLayout";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { EntryStepLayout as OnboardingLayout } from "@entry/EntryStepLayout";
import { useAddressSuggestion } from "@hooks";
import { Translations, i18n } from "@i18n";
import { useState } from "react";

export const ResidentialAddressRoute = () => {
  const [input, setInput] = useState("");

  const { data } = useAddressSuggestion({ input });

  const props: OnboardingLayoutProps = {
    title: i18n.t(Translations.ResidentialAddressRouteTitle),
    subContent: <AddressSuggestionList data={data} />,
  };

  return (
    <OnboardingLayout {...props}>
      <SearchInput
        label={i18n.t(Translations.ResidentialAddressRouteInputLabel)}
        value={input}
        setValue={setInput}
      />
      <Spacing size={SpacingSizes.M} />
    </OnboardingLayout>
  );
};
